import * as React from 'react'
import { Link as StyledLink } from '@chakra-ui/core'
import { Button } from '../button'
import { colors } from '../../base/colors'
// import styled from '@emotion/styled'
// import { css } from '@emotion/core'
// import {
// 	space,
// 	layout,
// 	compose
// } from 'styled-system'
// import { componentThemeGet } from '../../utils/index';

// const StyledLink = styled.a<any>`
// 	color: ${componentThemeGet('link', 'default.color', 'colors.grays.9')};
// 	cursor: pointer;
// 	display: inline-block;
// 	text-decoration: none;
// `

// const StyledInlineLink = styled(StyledLink)<any>`
// 	&:after {
// 		display:block;
// 		content: '';
// 		border-bottom: solid 3px ${componentThemeGet('link', 'underline.color', 'colors.grays.9')};
// 		transform: scaleX(0);
// 		transition: transform 250ms cubic-bezier(0.785, 0.135, 0.15, 0.86);
// 		transform-origin: 0% 50%;
// 		width: inherit;
// 	}

// 	&:hover {
// 		color: ${componentThemeGet('link', 'hover.color', 'colors.grays.8')};
// 		text-decoration: none;

// 		&:after {
// 			transform: scaleX(1);
// 		}
// 	}
// `
// StyledLink.displayName = 'Link'

// const StyledBlockLink = styled(StyledLink)`
// 	display: block;

// 	&:hover {
// 		color: ${componentThemeGet('link', 'hover.color', 'colors.grays.8')};
// 		text-decoration: underline;
// 	}

// 	${compose(
// 		space,
// 		layout
// 	)}
// `
// StyledBlockLink.displayName = 'BlockLink'

// const Link = StyledInlineLink
// const BlockLink = StyledBlockLink

const linkStyleProps = {
	_after: {
		display: 'block',
		content: '""',
		borderBottomStyle: 'solid',
		borderBottomWidth: '3px',
		borderBottomColor: colors.brand.gray.base,
		transform: 'scaleX(0)',
		transition: 'transform 250ms cubic-bezier(0.785, 0.135, 0.15, 0.86)',
		transformOrigin: '0% 50%',
		width: 'inherit'
	},
	_hover: {
		color: 'inherit',
		textDecoration: 'none',
		'&:after': {
			transform: 'scaleX(1)'
		}
	}
}

const Link: React.FC<any> = (props: any): React.ReactElement => {
	const {
		variant,
		disableUnderline = false,
		...rest
	} = props

	let styles: any = {}

	if (disableUnderline !== true) {
		styles = {...linkStyleProps}
		if (variant === 'light') {
			styles._after.borderBottomColor = colors.brand.white.base
		} else {
			styles._after.borderBottomColor = colors.brand.gray.base
		}
	}

	return (
		<StyledLink
			display="inline-block"
			{...styles}
			{...rest}
		/>
	)
}

const BlockLink: React.FC<any> = (props: any): React.ReactElement => {
	const {
		variant,
		...rest
	} = props

	return (
		<StyledLink
			display="block"
			{...rest}
		/>
	)
}

const ButtonLink: React.FC<any> = (props: any): React.ReactElement => {
	return <Button as="a" {...props} />
}

export {
	Link,
	BlockLink,
	ButtonLink
}

export default Link
